export default {
    cloud_name: 'dopzhtmgt',
    upload_preset: 'default_preset'
};